import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { NewLoader } from './NewLoader';
import InvalidPage from './InvalidPage';
import TransparentHeader from './TransparentHeader';
import FirstPartyData from './FirstPartyData';
import SuccessNotification from './SuccessNotification';

export default function FirstPartyDataRoute() {

    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [customerKey, setCustomerKey] = useState(0);
    const [brandId, setBrandId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [showSuccessNotification, setShowSuccessNotification] = useState(false);

    useEffect(() => {
        const formParam = searchParams.get("form");

        if (formParam) {
            const params = formParam.split('x');

            if (params.length >= 4) {
                setCustomerKey(parseInt(params[0], 10) || 0);
                setBrandId(parseInt(params[3], 10) || 0);
                setBatchId(parseInt(params[2], 10) || 0);
            }
            else if (params.length === 3) {
                setCustomerKey(parseInt(params[0], 10) || 0);
                setBrandId(parseInt(params[1], 10) || 0);
                setBatchId(parseInt(params[2], 10) || 0);
            }
        }
        setIsLoading(false);
    }, [searchParams]);

    const handleClose = () => {
        const formParam = searchParams.get("form");
        if (formParam) {
            window.location.href = `/ar/multiexp?exp=${formParam}`;
        }
        else {
            window.history.back();
        }
    }

    if (isLoading) {
        return <NewLoader />
    }

    if (!customerKey || !brandId || !batchId) {
        return <InvalidPage />
    }

    return (
        <>
            <div style={{ height: "100vh", backgroundColor: "#000" }}>
                <TransparentHeader />
                <FirstPartyData
                    customerKey={customerKey}
                    brandId={brandId}
                    batchId={batchId}
                    onClose={handleClose}
                    setShowSuccessNotification={setShowSuccessNotification}
                />
            </div>

            <SuccessNotification
                open={showSuccessNotification}
                onCloseNotification={() => setShowSuccessNotification(false)}
            />
        </>
    )
}
